import * as React from 'react';
import { ValidatorUtil } from '../utils/validator';

export const useValidation = (value: any, mask: string | RegExp) => {
  const [isValid, setIsValid] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (typeof mask === 'string') {
      if (!!ValidatorUtil.checkValidator(mask)) {
        return setIsValid(ValidatorUtil.checkValidator(mask)(value));
      }
      return setIsValid(false);
    } else {
      return setIsValid(mask?.test(value));
    }
  }, [value, mask]);

  return isValid;
};
